<template>
  <div >
    <portlet
            :actionsBlock="true"
            :icon="'fad fa-pencil'"
            :title="$t('instructions.createInstruction')"
    >
      <template slot="actionsBlock">
        <back-button :link="'instructions'"/>
      </template>
      <template slot="portletBody">
        <InstructionsForm></InstructionsForm>
      </template>
    </portlet>
  </div>
</template>

<script>
import InstructionsForm from '../../components/instructions/InstructionsForm';

  export default {
    name: 'CreateInstruction',
    components: {
      InstructionsForm
    },
    provide() {
      return {
        $validator: this.$validator
      };
    },
    props: {

    },
    mixins: [],
    data() {
      return {

      };
    },

    methods: {

    },
    computed: {

    }
  };
</script>
